import { redirectWithSsoHandoff } from './ssoHandoff';

const DEFAULT_SCHOOL_APP_URL = 'https://teacher.tinywins.ai';

/** Base URL for the Tinywins-school app (teacher / daycare). */
export function getSchoolAppUrl(): string {
  const fromEnv = import.meta.env.VITE_SCHOOL_APP_URL as string | undefined;
  if (fromEnv?.trim()) {
    return fromEnv.trim().replace(/\/$/, '');
  }
  return DEFAULT_SCHOOL_APP_URL;
}

/** Pass active Cognito session to school app so user is not prompted to sign in again. */
export async function redirectToSchoolApp(): Promise<void> {
  await redirectWithSsoHandoff(getSchoolAppUrl());
}

export function isSchoolRole(role: string | null | undefined): boolean {
  return role === 'TEACHER' || role === 'DAYCARE';
}
